// removed by extract-text-webpack-plugin
module.exports = {"defaultTheme":"itemActions-module_defaultTheme_z7_4l","actionsContainer":"itemActions-module_actionsContainer_3Aqtb","action":"itemActions-module_action_ynHWV","active":"itemActions-module_active_2lLlY","icon":"itemActions-module_icon_-ugTk"};


//////////////////
// WEBPACK FOOTER
// ./client/components/itemCard/common/itemActions.module.css
// module id = 1017
// module chunks = 1